<div class="card-body" *ngIf="{mockDataPreview: mockDataPreview$ | async} as context">
	<div class="header-bar">
		<div class="users-selection">
			<div class="user-select-lookup">
				<label>Source</label>
				<dx-lookup [dataSource]="sourceSystems" displayExpr="name" valueExpr="id" [(ngModel)]="sourceSystem" (onValueChanged)="onSourceSystemChange($event)"></dx-lookup>
			</div>
			<i class="far fa-arrow-right"></i>
			<div class="user-select-lookup">
				<label>Target</label>
				<dx-lookup [dataSource]="targetSystems" displayExpr="name" valueExpr="id" [(ngModel)]="targetSystem"></dx-lookup>
			</div>
		</div>
	</div>
	<div class="preview-container">
		<button *ngIf="context.mockDataPreview" class="btn btn-sm btn-warning upload-button" (click)="uploadMockData()">Upload</button>
		<dx-data-grid *ngIf="context.mockDataPreview" [dataSource]="context.mockDataPreview" height="100%">
			<dxo-selection mode="none"></dxo-selection>
			<dxo-filter-row [visible]="true"></dxo-filter-row>

			<dxi-column dataField="id" width="40px"></dxi-column>
			<dxi-column dataField="description"></dxi-column>
			<dxi-column dataField="linkTemplate"></dxi-column>
			<dxi-column dataField="dataLength" caption="Data length"></dxi-column>

			<dxi-column cellTemplate="actionsCellTemplate" [allowResizing]="false" [fixed]="true" fixedPosition="right" dataType="string" width="300px"></dxi-column>

			<div class="actions-cell" *dxTemplate="let d of 'actionsCellTemplate'">
				<button class="btn btn-sm btn-warning action-button" (click)="downloadMockData(d.data.id)">Download</button>
				<button class="btn btn-sm btn-warning action-button" (click)="deleteMockData([d.data.id])">Delete</button>
				<button class="btn btn-sm btn-warning action-button" [disabled]="!targetSystem" (click)="transferMockData([d.data.id])">Transfer</button>
			</div>
		</dx-data-grid>
		<div *ngIf="!context.mockDataPreview && !loading" class="select-message">Please select a source system</div>
		<div *ngIf="!context.mockDataPreview && loading" class="select-message">Loading...</div>
	</div>
</div>

<input style="display: none;" type="file" id="fileSelect" accept=".json"/>

<mock-data-create-modal></mock-data-create-modal>

<a id="linkanchor"></a>
